import { create } from "zustand";

export const useCartStore = create((set) => ({
  cart: [],
  shopping: {},
  loading: false,
  addItem: (item) => {
    set((state) => {
      const indexItem = state.cart.findIndex(
        (i) => i.product_id === item.product_id
      );
      if (indexItem > -1) {
        const updatedCart = state.cart.map((cartItem, index) => {
          if (index === indexItem) {
            return { ...cartItem, count: +cartItem.count + 1 };
          } else {
            return cartItem;
          }
        });

        return { cart: updatedCart };
      } else {
        return { cart: [...state.cart, { ...item, count: 1 }] };
      }
    });
  },
  removeItem: (item) => {
    set((state) => {
      const updatedCart = state.cart.map((cartItem) => {
        if (cartItem.product_id === item.product_id) {
          return { ...cartItem, count: cartItem.count - 1 };
        } else {
          return cartItem;
        }
      });

      return { cart: updatedCart.filter((i) => i.count > 0) };
    });
  },
  setCart: (newData) =>
    set(() => ({
      cart: [...newData],
    })),
  setShopping: (newShopping) =>
    set((state) => ({
      shopping: { ...state.shopping, ...newShopping },
    })),
  setLoading: (newState = false) =>
    set(() => ({
      loading: newState,
    })),
}));
